module.exports = __webpack_public_path__ + "static/media/the-suburbs.dd53687f.jpg";